import { observable } from 'mobx';

import {
  BaseFormModel,
  displayName,
  isEmail,
  isRequired,
} from '../../BaseForm';

class EmailNewModalForm extends BaseFormModel {
  @observable
  @displayName('title.email.contact')
  @isRequired()
  @isEmail()
  contactEmail = '';

  @observable
  @displayName('title.email.subject')
  @isRequired()
  subject = '';

  @observable
  @displayName('title.email.message')
  @isRequired()
  message = '';
}

export default EmailNewModalForm;
